import { Box, LinearProgress as MuiLinearProgress, Typography } from '@mui/material';

import { formatNumber } from '../../utils/formatNumber/formatNumber';

interface LinearProgressProps {
  value: number;
  showPercentage?: boolean;
}

export const LinearProgress = ({ value, showPercentage = true }: LinearProgressProps) => {
  return (
    <Box sx={{ alignItems: 'center', display: 'flex', gap: 2, mb: 2 }}>
      <Box sx={{ mr: 1, width: '100%' }}>
        <MuiLinearProgress variant="determinate" value={value} />
      </Box>
      {showPercentage ? (
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">
            {formatNumber(value, { style: 'percent' })}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};
